import React from 'react';
import moment from 'moment';
import FicheMatchUser from "../dataDisplay/FicheMatchUser";
import './FilterMatchSelectionMenu.css'

const FilterMatchSelectionMenu = ({
                                      resultsLimit,
                                      hideFullSponsors,
                                      searchType,
                                      onResultsLimitChange,
                                      onSearchTypeChange,
                                      onHideFullSponsors,
                                      onLaunchSearch,
                                      availabilityDate,
                                      onAvailabilityDateChange,
                                      selectedSponsor,
                                      facultyList,
                                      countryList,
                                      languageList,
                                      preferencesList,
                                      interestsList,
                                      sessionsList,
                                      studyLevelList,
                                      matchesList}) => {

    const [isSelectedOpen, setIsSelectedOpen] = React.useState(false);

    const safeFacultyList = Array.isArray(facultyList) ? facultyList : [];
    const safeCountryList = Array.isArray(countryList) ? countryList : [];
    const safeLanguageList = Array.isArray(languageList) ? languageList : [];
    const safeSessionsList = Array.isArray(sessionsList) ? sessionsList : [];
    const safeStudyLevelList = Array.isArray(studyLevelList) ? studyLevelList : [];
    const safeMatchesList = Array.isArray(matchesList) ? matchesList : [];

    const selectedSponsorDisplayData =
        safeMatchesList.find((item) => Number(item.id) === Number(selectedSponsor?.id)) || selectedSponsor;

    const selectedAge = moment().diff(selectedSponsorDisplayData?.birthdate, 'years');
    const selectedFaculty = safeFacultyList.find((fac) => fac.id === selectedSponsorDisplayData?.faculty_id)?.name || "Faculte inconnue";
    const selectedCountry = safeCountryList.find((country) => country.id === selectedSponsorDisplayData?.originCountry_id)?.name || "Pays inconnu";
    const selectedPrimaryLang = safeLanguageList.find((lang) => lang.id === selectedSponsorDisplayData?.languagePrimary_id)?.name || "Inconnue";
    const selectedSession = safeSessionsList.find((session) => session.id === selectedSponsorDisplayData?.firstSession_id)?.name || "Inconnue";
    const selectedStudyCycle = safeStudyLevelList.find((lvl) => lvl.id === selectedSponsorDisplayData?.studyLevel)?.name || "Inconnu";
    const selectedGender = selectedSponsorDisplayData?.gender === 1 ? "Homme" : (selectedSponsorDisplayData?.gender === 0 ? "Femme" : "Non precise");
    const selectedVeteranStatus = selectedSponsorDisplayData?.isVeteran === 1 ? "Veteran" : "Nouveau";
    const selectedAvailability = selectedSponsorDisplayData?.availabilityDate ? moment(selectedSponsorDisplayData.availabilityDate).format("YYYY/MM/DD") : "Inconnue";
    const selectedCurrentLoad = selectedSponsorDisplayData?.inChargeOfClientsID?.length ?? selectedSponsorDisplayData?.sponsorLoadCurrent ?? 0;
    const selectedMaxLoad = selectedSponsorDisplayData?.sponsorLoad ?? 0;
    const selectedIsFull = selectedMaxLoad > 0 && selectedCurrentLoad >= selectedMaxLoad;
    const selectedAvailabilityMoment = selectedSponsorDisplayData?.availabilityDate ? moment(selectedSponsorDisplayData.availabilityDate) : null;
    let selectedAvailabilityClass = "unknown";
    if (selectedAvailabilityMoment && selectedAvailabilityMoment.isValid()) {
        if (selectedAvailabilityMoment.isSame(moment(), "day")) selectedAvailabilityClass = "today";
        else if (selectedAvailabilityMoment.isBefore(moment(), "day")) selectedAvailabilityClass = "past";
        else selectedAvailabilityClass = "future";
    }
    const selectedVeteranClass = selectedSponsor?.isVeteran === 1 ? "veteran" : "newcomer";

    return (
        <div className="matchFilterMenu">
            <div className="containerfilterSelectionMenuBox modernFilterBox">
                <div className="row filterHeaderRow">
                    <div className="col-md-12 filterHeaderCol">
                        <div className="filterSelectionMenuHeader">
                            <div className="filterSelectionMenuTitle">
                                Selection de jumelage
                            </div>
                            <div className="filterSelectionMenuSubtitle">Ajuste les criteres puis choisis un parrain ou une marraine a droite.</div>
                        </div>
                    </div>
                </div>
                <div className="row filterGridRow">
                    <div className="col-md-6 filterControlsColumn">
                        <div className="row filterControlRow">
                            <div className="col-md-8"><label >Limite des résultats de recherche</label></div>
                            <div className="col-md-4"><input type="text" className="limitSearchResults" name="limitSearchResults" value={resultsLimit} onChange={onResultsLimitChange} /></div>
                        </div>
                        <div className="row filterControlRow">
                            <div className="col-md-8"><label >Respecter les préférences de l'étudiant étranger</label></div>
                            <div className="col-md-4">
                                <input
                                    type="radio"
                                    id="suggested"
                                    name="searchResults"
                                    onChange={onSearchTypeChange}
                                    checked = {searchType === "suggested"}
                                    value = "suggested"
                                /><label htmlFor="suggested">Oui</label>
                                <br/>
                                <input
                                    type="radio"
                                    id="all"
                                    name="searchResults"
                                    onChange={onSearchTypeChange}
                                    checked ={searchType === "all"}
                                    value = "all"
                                /><label htmlFor="all">Non</label>
                            </div>
                        </div>
                        <div className="row filterControlRow">
                            <div className="col-md-8"><label >Cacher les PM complets</label></div>
                            <div className="col-md-4">
                                <input
                                    type="checkbox"
                                    id="sponsorLoadDisplay"
                                    name="showOverloadedSponsors"
                                    onChange={onHideFullSponsors}
                                    checked = {hideFullSponsors}
                                />
                            </div>
                        </div>
                        <div className="row filterControlRow">
                            <div className="col-md-8"><label htmlFor="maxResults">Date de disponibilité des parrains et marraines</label></div>
                            <div className="col-md-4">
                                <input
                                    type="date"
                                    data-rule-dateiso={true}
                                    className="availabilityDateInput"
                                    name="availabilityDate"
                                    value={availabilityDate}
                                    onChange={onAvailabilityDateChange}
                                />
                            </div>

                        </div>
                        <div className="row filterSelectionMenuFooter">
                            <div className="col-md-12">
                                <button className="btn btn-black updateMatchesButton" onClick={onLaunchSearch}>Mettre à jour la liste des matches</button>
                            </div>
                        </div>

                    </div>
                    <div className="col-md-6 filterSelectedColumn">
                        {!objectIsEmpty(selectedSponsor)?<>
                            <article className="currentSelected selectedSponsorCard selectedAccordionItem">
                                <div className="selectedAccordionTrigger">
                                    <div className="selectedSummary">
                                        <span className="selectedName">{selectedSponsorDisplayData.firstName} {selectedSponsorDisplayData.lastName} ({Number.isNaN(selectedAge) ? "-" : selectedAge} ans)</span>
                                        <span className="selectedFaculty">{selectedFaculty}</span>

                                        <span className="selectedMetaRow">
                                            <span className="matchScoreBadge">Score: {selectedSponsorDisplayData?.matchAttributes?.score ?? 0}</span>
                                            <span className={`sponsorLoadBadge ${selectedIsFull ? "overLimit" : ""}`}>Charge: {selectedCurrentLoad}/{selectedMaxLoad}</span>
                                            {selectedIsFull && <span className="sponsorLoadFullBadge">Complet</span>}
                                            <span className={`sponsorMetaItem availability ${selectedAvailabilityClass}`}>Dispo: {selectedAvailability}</span>
                                            <span className={`sponsorMetaItem status ${selectedVeteranClass}`}>Statut: {selectedVeteranStatus}</span>
                                            <span className="sponsorMetaItem neutral">Sexe: {selectedGender}</span>
                                        </span>

                                        <span className="selectedMetaInlineRow">
                                            <span className="selectedMetaInline">Session: {selectedSession}</span>
                                            <span className="selectedMetaInline">Pays: {selectedCountry}</span>
                                            <span className="selectedMetaInline">Langue maternelle: {selectedPrimaryLang}</span>
                                            <span className="selectedMetaInline">Cycle: {selectedStudyCycle}</span>
                                        </span>
                                    </div>
                                    <button
                                        type="button"
                                        className="selectedAccordionCta"
                                        onClick={() => setIsSelectedOpen((prev) => !prev)}
                                        aria-expanded={isSelectedOpen}
                                    >
                                        {isSelectedOpen ? "Masquer" : "Details"}
                                    </button>
                                </div>

                                {isSelectedOpen &&
                                <div className="selectedAccordionPanel">
                                    <FicheMatchUser
                                        data={selectedSponsorDisplayData}
                                        facultyList={facultyList}
                                        countryList={countryList}
                                        languageList={languageList}
                                        preferencesList={preferencesList}
                                        interestsList={interestsList}
                                        sessionsList={sessionsList}
                                        studyLevelList={studyLevelList}
                                        compact={true}
                                    />
                                </div>
                                }
                            </article>
                        </>
                            :
                        <>
                            <div className="noSelectedSponsor">Aucun jumelage associé.</div>
                        </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

function objectIsEmpty(obj) {
    if (obj === undefined) return true;
    else if (obj === null) return true;
    else if (obj === "") return true;
    else return (Object.keys(obj).length === 0 && obj.constructor === Object)
}

export default FilterMatchSelectionMenu;